import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from '../../helpers/api/apiCore';

// helpers
import {
    login as loginApi,
    logout as logoutApi,
    signup as signupApi,
    forgotPassword as forgotPasswordApi,
} from '../../helpers/';

// actions
import { authApiResponseSuccess, authApiResponseError } from './actions';

// constants
import { AuthActionTypes } from './constants';

type UserData = {
    payload: {
        Active: boolean;
        Address: string;
        CompanyId: number;
        CompanyName: string;
        CompanyStatus: number;
        Email: string;
        IdentificationNumber: string;
        IdentificationType: number;
        IsCertificated: boolean;
        Phone: string;
        Username: string;
        WebSiteUrl: string;
        expiration: string;
        Password: string;
       // role: string;
        token: string;
    };
    type: string;
};
const api = new APICore();
/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({ payload: { Username, Password }, type }: UserData): SagaIterator {
    
    try {
      const response = yield call(loginApi, { Username, Password });
      const data = {
        ...response.data.Company,
        ...response.data.Token,
        role:"Admin"
      }
        // NOTE - You can change this according to response format from your api
        api.setLoggedInUser(data);
        setAuthorization(data['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, data));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}
/**
 * Logout the user
 */
function* logout(): SagaIterator {
    try {
        yield call(logoutApi);
        api.setLoggedInUser(null);
        setAuthorization(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* signup({ payload: { CompanyName, Email, Password } }: UserData): SagaIterator {
    try {
        const response = yield call(signupApi, { CompanyName, Email, Password });
        const user = response.data;
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* forgotPassword({ payload: { Email } }: UserData): SagaIterator {
    try {
        const response = yield call(forgotPasswordApi, { Email });
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
    }
}
export function* watchLoginUser() {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLogout() {
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchSignup(): any {
    yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

function* authSaga() {
    yield all([fork(watchLoginUser), fork(watchLogout), fork(watchSignup), fork(watchForgotPassword)]);
}

export default authSaga;
